(function () {
    angular
        .module("app")
        .service("BucketService", BucketService);

    BucketService.$inject = ["appConfig","$state"];

    function BucketService(appConfig,$state) {
        var svc = {};
        window._bucketService = svc;
        

        svc.loadPropsAndMethods = (callerScope) => {
            callerScope.buckets = [];

            // ======================================
            // callerScope.initBuckets: initialize buckets
            // ======================================
            callerScope.initBuckets = () => {
                //console.log('callerScope.initBuckets');


                for( let i = 0 ; i < appConfig.searchParams.searchViews.length ; i++){

                    callerScope.buckets.push({
                        name: appConfig.searchParams.searchViews[i].name,
                        type: appConfig.searchParams.searchViews[i].type,
                        display: appConfig.searchParams.searchViews[i].display,
                        interfaceName: appConfig.searchParams.searchViews[i].interfaceName,
                        searchViewName: appConfig.searchParams.searchViews[i].searchViewName,
                        pageSize: appConfig.searchParams.searchViews[i].pageSize || 10,
                        collections: appConfig.searchParams.searchViews[i].collections,
                        selected: callerScope.views.indexOf((i).toString()) > -1 ? true : false,
                        index: i,
                        searchResults: [],
                        resultsCount: 0,
                        searchXmlResults: ''
                    })
                }
            };

            callerScope.bucketsEnabled = true;

            // ======================================
            // callerScope.setBucket: on bucket/tab click
            // ======================================
            callerScope.setBucket = (bucket,index) => {

                if(callerScope.bucketsEnabled){

                    if(!callerScope.searchMultipleViews && callerScope.views.length > 1){
                        // $state.go('search',{ q: callerScope.searchTerm, v: callerScope.views[0]})
                        $state.go(callerScope.route.name,{q: callerScope.searchTerm, v: callerScope.views[0]})
                    }
                    let v;
                    if(callerScope.searchMultipleViews){
                        let x = callerScope.views.indexOf(index.toString());
                        // console.log(x)
                        if(x > -1 ){
                            callerScope.views.splice(x,1);
                        }
                        else {
                            callerScope.views.push(index.toString());
                            callerScope.views.sort();
                        }
                        v = callerScope.views.join(',')
                        // console.log(callerScope.views, v)
                    }
                    else {
                        v = index;
                    }
                    if(!callerScope.buckets[index].selected || callerScope.searchMultipleViews){
                        // $state.go('search',{ q: callerScope.searchTerm, v: v})

                        if (typeof window.localStorage != "undefined") {
                            callerScope.localStorage.removeCurrentSearchItems();
                        }

                        let v = callerScope.views.length ? callerScope.views.join(',') : '0';
                        let t = callerScope.buckets[index].name;
                        const routeParams = {
                            q: callerScope.searchTerm,
                            v: index,
                            tab: t,
                            page: 1
                        };
                        $state.go(callerScope.route.name,routeParams)
                    }
                }
            }



            // ======================================
            // Search Buckets panning UX/UI
            // ======================================
            $(document).ready(function(){

                let _w = window;
                let sbScope = callerScope;
                _w.searchBuckets = document.getElementById("search-buckets");
                _w.searchBucketsNav = document.getElementById("search-buckets-nav");
                _w.searchBucketsNavLeftArrow = document.getElementById("buckets-nav-left-arrow");
                _w.searchBucketsNavRightArrow = document.getElementById("buckets-nav-right-arrow");

                // TODO: although current panning is working, it could be better. ...really don't need so much info.
                function getSearchBucketsNavCoordinates(){
                    const _bko = $(_w.searchBucketsNav).offset();
                    const _bkparent = $(_w.searchBucketsNav).parent();
                    const _bkpw = $(_bkparent).css('width');

                    const _bw = $('body').width();
                    const _bkw = parseInt($(_w.searchBucketsNav).css("width"));
                    const _bkl = parseInt($(_w.searchBucketsNav).css("left"));
                    const _bkr = parseInt($(_w.searchBucketsNav).css("right"));

                    const _bkr2_ = (parseInt(_bkpw)-(_bkl+_bkw))
                    const _bkr2 = _bkr2_<0 ? _bkr2_+1 : _bkr2_;

                    const _p={
                        bucketsWidth: _bkw,
                        bucketsLeft: _bkl,
                        bucketsRight: _bkr || _bkr2, // _bkr2 for iPhone...
                        bucketsOffsetX:_bko.left,
                        bucketsOffsetY:_bko.top,
                        bodyWidth: _bw,
                        diffWidth: _bw-_bkw,
                        buckets:_w.searchBucketsNav
                    };

                    return(_p)
                }

                sbScope.setSearchBucketsNavArrows = () =>{
                    setTimeout(function(){
                        const coords = getSearchBucketsNavCoordinates();

                        if (coords.bucketsLeft >= 0) {
                            _w.searchBucketsNavLeftArrow.classList.remove('show-arrow');
                          } else {
                              _w.searchBucketsNavLeftArrow.classList.add('show-arrow');
                          }
  
                          if (coords.bucketsRight >= -25) {
                              _w.searchBucketsNavRightArrow.classList.remove('show-arrow');
                          } else {
                              _w.searchBucketsNavRightArrow.classList.add('show-arrow');
                          }
  
                    },1)
                }

                _w.bodyWidth = $('body').width();

                $( window ).resize(function() {
                    const bodyWidthDiff = $('body').width() - _w.bodyWidth;
                    const coords = getSearchBucketsNavCoordinates();
                    const _left = Math.min($('body').width()-700,0)
                    if(coords.bucketsLeft<0 && _left>coords.bucketsLeft){
                        $(_w.searchBucketsNav).css('left',parseInt(_left).toString()+"px")
                        localStorage.setItem("searchBucketsNavCssLeft", _left);
                    }
                    _w.bodyWidth = $('body').width()
                    sbScope.setSearchBucketsNavArrows()
                });


                sbScope.searchBucketSlideTo = (_left) => {
                    $(_w.searchBucketsNav).addClass('pan').css('left',parseInt(_left).toString()+"px")
                    localStorage.setItem("searchBucketsNavCssLeft", _left);
                    setTimeout(function(){
                        $(_w.searchBucketsNav).removeClass('pan')
                        sbScope.setSearchBucketsNavArrows()
                    },310)
                }

                sbScope.searchBucketsNextSlidePosition = (dir) => {
                    // 'dir' is panning direction: left or right

                    const coords = getSearchBucketsNavCoordinates();
                    const offset = 60;
                    const minSlidePostition = coords.diffWidth-30;
                    const maxSlidePostition = 0;

                    let newLeft = 0;
                    let _l = Math.max(coords.diffWidth-offset,-200);

                    switch(dir){
                        case "left":
                            newLeft = Math.max(coords.bucketsLeft+_l,minSlidePostition);
                            break;

                        case "right":
                            newLeft = Math.min(coords.bucketsLeft-_l,maxSlidePostition);
                            break;

                        default:
                            //console.error('INVALID DIRECTION: dir=',dir);
                            break;
                    }
                    if(newLeft <= maxSlidePostition && coords.bodyWidth < 712){
                        sbScope.searchBucketSlideTo(newLeft)
                    }
                }

                sbScope.setSearchBucketsNavArrows()

                sbScope.searchBucketsNavLeft = parseInt(window.getComputedStyle(_w.searchBucketsNav).left)

                //hammertime.on("panleft panright panstart panend doubletap tap press", function(ev) {
                const hammerPanBuckets = new Hammer(_w.searchBucketsNav);
                hammerPanBuckets.on("panleft panright panstart panend", function(ev) {
                    window._lastEv = ev;
                    const transitionDelay = 500;

                    const bWidth = $('body').width();
                    const pWidth = parseInt($(_w.searchBuckets).css("width"));
                    const bkWidth = parseInt($(_w.searchBucketsNav).css("width"));
                    const offset = 30;

                    const diffWidth = Math.min(bWidth-offset-bkWidth, 0)
                    const minLeft = diffWidth ; //-330;


                    if(true){

                        switch(ev.type) {
                            case 'panstart':
                                sbScope.bucketsEnabled = false;
                            break;
                            case 'panend':
                                sbScope.searchBucketsNavLeft = parseInt(window.getComputedStyle(_w.searchBucketsNav).left);
                                if(typeof _w.localStorage != "undefined"){
                                    _w.localStorage.setItem("searchBucketsNavCssLeft",sbScope.searchBucketsNavLeft)
                                }

                                setTimeout(function(){
                                  sbScope.bucketsEnabled = true;
                                },10);

                                break;

                            case 'panright':
                            case 'panleft':
                                sbScope.bucketsEnabled = false;
                                const _newLeft = sbScope.searchBucketsNavLeft + ev.deltaX;
                                const newLeft = _newLeft < 0 ? Math.max(_newLeft, minLeft) : 0;
                                $(_w.searchBucketsNav).css('left', parseInt(newLeft).toString() + "px");
                                break;
                        }
                    }
                    else
                    {
                        switch(ev.type){
                            case 'panright':
                                sbScope.bucketsEnabled = false;
                                sbScope.searchBucketsNextSlidePosition("right")

                                hammerPanBuckets.get('pan').set({ enable: false });
                                setTimeout(function(){
                                    hammerPanBuckets.get('pan').set({ enable: true });
                                    sbScope.bucketsEnabled = true;
                                },transitionDelay);

                                break;

                            case 'panleft':
                                sbScope.bucketsEnabled = false;
                                sbScope.searchBucketsNextSlidePosition("left")
                                hammerPanBuckets.get('pan').set({ enable: false });
                                setTimeout(function(){
                                    hammerPanBuckets.get('pan').set({ enable: true });
                                    sbScope.bucketsEnabled = true;
                                },transitionDelay);

                                break;
                        }
                    }
                    
                    sbScope.setSearchBucketsNavArrows()
                });

                setTimeout(function(){
                    if(typeof _w.localStorage != "undefined"){
                        if(_w.localStorage.getItem("searchBucketsNavCssLeft")){
                            const _left = parseInt(localStorage.getItem("searchBucketsNavCssLeft"))
                            $(_w.searchBucketsNav).css('left',parseInt(_left).toString()+"px");
                            sbScope.searchBucketsNavLeft = parseInt(_left);
                        }
                    }
                
                    sbScope.setSearchBucketsNavArrows()

                },0)

 

            }) // $(document).ready

            // ======================================
            // End Search Buckets panning UX/UI
            // ======================================


        } // enc callerScope


        return svc;
    }
})();
